import { render, staticRenderFns } from "./PatternVersion.vue?vue&type=template&id=1350d6ab&scoped=true&"
import script from "./PatternVersion.vue?vue&type=script&lang=ts&"
export * from "./PatternVersion.vue?vue&type=script&lang=ts&"
import style0 from "./PatternVersion.vue?vue&type=style&index=0&id=1350d6ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350d6ab",
  null
  
)

export default component.exports